<div
  class="grid grid-nogutter flex-nowrap frm-layout-root"
  style="height: 100%">
  <div class="left-menu-wrapper">
    <crm-menu-component
      [minimized]="menuMinimized"
      [devEnvironment]="devEnvironment"
      (toggleMinimized)="onMenuToggle($event)"></crm-menu-component>
  </div>
  <div
    class="left-menu-offset"
    [class.minimized]="menuMinimized"></div>
  <div
    class="main-content w-full sm:block frm-filters-ui-v2 frm-workspace-v2"
    [class.minimized]="!menuMinimized">
    <router-outlet></router-outlet>
  </div>
</div>

<frm-informer-bottom-bar [minimized]="menuMinimized"></frm-informer-bottom-bar>

<crm-form-sidebar></crm-form-sidebar>
